/**
 * Clés venues des DONNÉES (en-têtes de colonnes d'un fichier, codes de champs, réponses) : jamais lues par
 * `obj[cle]`, qui remonterait le prototype (`constructor`, `toString`…) ni écrites dans un objet ordinaire
 * (`__proto__`). Lecture par `own()`, écriture dans un dictionnaire sans prototype (`dict()`).
 */
export function own<T>(obj: Readonly<Record<string, T>> | null | undefined, key: string): T | undefined {
  return obj != null && Object.hasOwn(obj, key) ? obj[key] : undefined;
}

export function dict<T>(entries?: Iterable<readonly [string, T]>): Record<string, T> {
  const out = Object.create(null) as Record<string, T>;
  if (entries) for (const [k, v] of entries) out[k] = v;
  return out;
}

/** Copie avec une clé changée (dictionnaire sans prototype). */
export function withKey<T>(obj: Readonly<Record<string, T>>, key: string, value: T): Record<string, T> {
  const out = dict(Object.entries(obj));
  out[key] = value;
  return out;
}

/** Copie sans une clé. */
export function withoutKey<T>(obj: Readonly<Record<string, T>>, key: string): Record<string, T> {
  return dict(Object.entries(obj).filter(([k]) => k !== key));
}
